import { SidebarModal } from '@domain-group/suit-theme'
import useOrderItem from '@hooks/useOrderItem'

import { OrderItemModel } from '@models/types'

const OrderItemListItem = ({ item }:{item: OrderItemModel}) => {
  const {
    id, options_string, quantity, title,
  } = item
  const {
    callbacks: {
      manageProviderOrderItemModal,
    },
  } = useOrderItem({ id })

  return (
    <SidebarModal.ListItem
      // @ts-expect-error TS2322
      forwardProps={{
        paddingRight: 'medium',
      }}
      secondaryText={`#${id}`}
      title={`${quantity} x ${title} ${options_string}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModal.ListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModal.ListItem.Icon
          onClick={() => manageProviderOrderItemModal()}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModal.ListItem.Actions>
    </SidebarModal.ListItem>
  )
}

export default OrderItemListItem
